module.exports = __webpack_public_path__ + "img/birchmorej.13f12a83.jpg";